import {
  HUSEIERNE_HOUSE_CONTENTS_INTRO_STEP,
  HUSEIERNE_HOUSE_CONTENTS_PRICE_STEP,
} from "Features/CheckPrice/Products/RiskProducts/HouseProducts/HuseierneHouseContents";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { booleanToFormBoolean } from "Utils/formUtils";

export function mapFromCommerceHuseierneHouseContents(
  data: Record<string, any>,
): FormStates {
  return {
    [HUSEIERNE_HOUSE_CONTENTS_INTRO_STEP.id]: {
      addressSameAsHomeAddress: booleanToFormBoolean(
        data.addressSameAsHomeAddress,
      ),
      postNumber: data.address?.zipCode,
      city: data.address?.city,
      validPostNumber: !!data.address?.city,
      coverageAmount: data.coverageAmount,
    },
    [HUSEIERNE_HOUSE_CONTENTS_PRICE_STEP.id]: {
      coverage: data.coverageGroup,
    },
  };
}
